import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=63c67818&"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts&"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&id=63c67818&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports